import {Injectable} from '@angular/core';
import {Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AutoconsumoModalService {
  private readonly event: Subject<any> = new Subject<any>();
  private readonly inputInformation: Subject<any> = new Subject<any>();

  constructor() {
  }


  setModalEvent(event: any) {
    this.event.next(event);
  }

  getModalEvent(): Observable<any> {
    return this.event.asObservable();
  }

  setModalInputInformation(inputInformation: any) {
    this.inputInformation.next(inputInformation);
  }

  getModalInputInformation(): Observable<any> {
    return this.inputInformation.asObservable();
  }
}
